<template>
  <!-- XOL-67 (B5, V5 for v2.1), decision 45 as changed by 142, UX spec 2.5 / mock M-20 to M-23: the Step 4 bottom button. One un-sized button, Submit decision
       (E17: it locks the decision and moves the RTA to Finalize), then the hint under it, which the button names with aria-describedby. There is no
       Close RTA here any more: ending the RTA is Reject RTA…, the footer's own button. Presentational: it draws what `lib/rtaDecision.actionView` says and
       tells the parent it was pressed. The parent (RtaDetails) owns the gate (rtaStage.step3Action), the confirm (rtaDecision.finalizeConfirm, with the
       decision 49 warning when the decision was never e-mailed) and the command. B12 (decision 130): it is the MIDDLE cell of the step footer, so it has
       no rule of its own and is centred. -->
  <div class="rta-step4-action">
    <div class="rta-step-footer__row">
      <el-button
        ref="button"
        :type="view.type"
        :icon="view.icon"
        :disabled="view.disabled"
        :loading="view.loading"
        :aria-label="view.label"
        :aria-describedby="describedBy"
        @click="$emit('click')">{{ view.label }}</el-button>
      <small v-if="view.hint" :id="hintId" class="rta-stepfoot__hint">{{ view.hint }}</small>
      <small v-if="keptText" :id="keptId" class="rta-stepfoot__hint rta-step4-action__kept"><i class="fa fa-save" aria-hidden="true"></i> {{ keptText }}</small>
    </div>
  </div>
</template>


<script>
import * as rtaDecision from '@/lib/rtaDecision'

export default {
  name: 'RtaDecisionAction',

  props: {

    // rtaStage.step3Action: { visible, mode ('finalize' | null), enabled, reason ('not_closer' | 'pending' | 'response_changed' | 'locked' | '') }.
    action: {
      type: Object,
      required: true
    },

    // A flush or the command is in flight (a double click sends one command).
    busy: {
      type: Boolean,
      default: false
    },

    // The client's name, for the "changed its response" hint.
    telco: {
      type: String,
      default: ''
    },

    // The option whose review changed (the hint names it): the APPROVED option's number.
    changedOptionNo: {
      type: Number,
      default: null
    },

    // Who made that unsubmitted change (the summary's `approvedChangedByParty`, P-S1): 'towerco' says the Tower Co's own change (nobody to wait for), anything else
    // names the client.
    changedByParty: {
      type: String,
      default: null
    },

    // The sentence under the hint after an Unlock from Step 5 ("Finalize entries saved on … are kept …"), or ''.
    keptText: {
      type: String,
      default: ''
    }

  },

  computed: {
    view () {
      return rtaDecision.actionView(this.action, { telco: this.telco, changedOptionNo: this.changedOptionNo, changedByParty: this.changedByParty, busy: this.busy })
    },

    hintId () {
      return 'rta-step4-action-hint'
    },

    keptId () {
      return 'rta-step4-action-kept'
    },

    // The button names the lines that are drawn, hint first (decision 189).
    describedBy () {
      var ids = []

      if (this.view.hint) {
        ids.push(this.hintId)
      }

      if (this.keptText) {
        ids.push(this.keptId)
      }

      return ids.length ? ids.join(' ') : null
    }
  },

  methods: {
    focus () {
      var b = this.$refs.button

      if (b && b.$el && typeof b.$el.focus === 'function') {
        b.$el.focus()
      }
    }
  }
}
</script>


<style scoped>
  /* Step 4's bottom button, Submit decision (UX M-20), the middle cell of the step footer (B12, decision 130): the button with its hint under it, centred. */
  .rta-step-footer__row {display: flex; flex-direction: column; align-items: center; gap: 6px; text-align: center;}
  /* Decision 189: the same hint as RtaDetails' .rta-stepfoot__hint (scoped styles do not cross into this child). */
  .rta-stepfoot__hint {display: block; font-size: 12px; line-height: 1.5; color: #606266; max-width: 260px;}
  @media (max-width: 767px) {
    .rta-step-footer__row {align-items: stretch;}
    .rta-step-footer__row .el-button {width: 100%;}
    .rta-stepfoot__hint {max-width: none;}
  }
</style>
